<template>
  <div id="app">
    <div v-if="!isMobile">
      <router-view />
    </div>
    <div class="no-use" v-else>
      לא ניתן לשחק במשחק ממכשיר זה, יש להיכנס ממחשב עם מצלמה
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    isMobile() {
      return window.innerWidth < 640;
    }
  }
};
</script>

<style lang="scss">
@import '@/assets/scss/style.scss';
#app {
  font-family: $font-main;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.no-use {
  background-color: #fff;
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  direction: rtl;
  padding: 40px;
  font-size: 24px;
}
</style>
